import React from 'react';

import styles from './FundBookFooter.css';
import {
    RUSSEL_FUNDS,
    NO_MSTR_FUNDS,
    NO_LIPPER,
    USHY_FUNDS,
    USHI_FUNDS,
    TRANSPARENCY_TYPES
} from '../../utils/constants';

const ETFLinkFront =
    'https://www.troweprice.com/financial-intermediary/us/en/investments/etfs/';
const ETFLinkBack =
    '.html#primary-holdings,no-description-provided-portfolio-tracking';

const getLinkToETF = (ticker) =>
    ETFLinkFront +
    ({
        TCHP: 'blue-chip-growth-etf',
        TRBCX: 'blue-chip-growth-etf',
        TDVG: 'dividend-growth-etf',
        DGFT: 'dividend-growth-etf',
        TGRW: 'growth-stock-etf',
        TEQI: 'equity-income-etf',
        TSPA: 'equity-research-etf'
    }[ticker] || 'no-matching-etf-error') +
    ETFLinkBack;

const FundBookFooter = ({
    etf,
    trpCode,
    ticker,
    moneyMarket,
    transparencyTypeName
}) => (
    <React.Fragment>
        <div id="content-disclosures" className="footer-container">
            {etf && (
                <React.Fragment>
                    <div className="glossary footer-content">
                        <a
                            className="glossary"
                            href="/personal-investing/funds/glossary.html"
                        >
                            See Glossary for details on all data elements
                        </a>
                    </div>
                    <div className="footer-content bold-content">
                        ETFs are bought and sold at market prices, not NAV.
                        Investors generally incur the cost of the spread between
                        the prices at which shares are bought and sold. Buying
                        and selling shares may result in brokerage commissions
                        which will reduce returns.
                    </div>
                    {transparencyTypeName === TRANSPARENCY_TYPES.SEMI && (
                        <React.Fragment>
                            <div className="footer-content">
                                This ETF publishes a daily Proxy Portfolio, a
                                basket of securities designed to closely track
                                the daily performance of the actual portfolio
                                holdings. While the Proxy Portfolio includes
                                some of the ETFs holdings, it is not the actual
                                portfolio. Daily portfolio statistics will be
                                provided as an indication of the similarities
                                and differences between the Proxy Portfolio and
                                the actual holdings. The Proxy Portfolio and
                                other metrics, including Portfolio Overlap, are
                                intended to provide investors and traders with
                                enough information encourage transactions that
                                help keep the ETF’s market price close to its
                                NAV. There is a risk that market prices will
                                differ from the NAV, ETFs trading on the basis
                                of a Proxy Portfolio may trade at a wider
                                bid/ask spread than shares of ETFs that publish
                                their portfolios on a daily basis, especially
                                during periods of market disruption or
                                volatility and, therefore, may cost investors
                                more to trade.{' '}
                            </div>
                            <div className="footer-content">
                                The ETF’s daily Proxy Portfolio, Portfolio
                                Overlap and other tracking data are available{' '}
                                <a
                                    className="proxy-portfolio"
                                    href={getLinkToETF(ticker)}
                                >
                                    here
                                </a>.
                            </div>
                            <div className="footer-content">
                                Although the ETF seeks to benefit from keeping
                                its portfolio information confidential, others
                                may attempt to use publicly available
                                information to identify the ETF’s investment and
                                trading strategy. If successful, these trading
                                practices may have the potential to reduce the
                                efficiency and performance of the ETF.
                            </div>
                        </React.Fragment>
                    )}
                    <div className="footer-content">
                        Because the Fund’s shares are traded in the secondary
                        market, a broker may charge a commission to execute a
                        transaction in Shares, and an investor also may incur
                        the cost of the spread between the price at which a
                        dealer will buy Shares and the somewhat higher price at
                        which a dealer will sell Shares.
                    </div>
                </React.Fragment>
            )}

            {USHY_FUNDS.includes(trpCode) && (
                <div className="footer-content">
                    ** The T. Rowe Price US High Yield Fund (“Fund”) commenced
                    operations on May 19 2017. At that time the Fund received
                    all of the assets and liabilities of the Henderson High
                    Yield Opportunities Fund (the “Predecessor Fund”) and
                    adopted its performance and accounting history. The Fund and
                    the Predecessor Fund have substantially similar investment
                    objectives and strategies. The Predecessor Fund was managed
                    by the same portfolio manager as the Fund.
                </div>
            )}

            {['PRUIX', 'PREIX', 'PEXMX', 'POMIX', 'PIEQX'].includes(ticker) && (
                <div className="footer-content">
                    The fund may become nondiversified, as defined under the
                    Investment Company Act of 1940, solely as a result of a
                    change in relative market capitalization or index weighting
                    of one or more constituents of the Index.
                </div>
            )}

            {!etf && (
                <React.Fragment>
                    {!NO_LIPPER.includes(trpCode) && (
                        <div className="footer-content">
                            Source for Lipper data: Lipper Inc.
                        </div>
                    )}
                    {!moneyMarket &&
                        !NO_MSTR_FUNDS.includes(trpCode) && (
                            <div className="footer-content">
                                <sup>*</sup> © {new Date().getFullYear()}{' '}
                                Morningstar, Inc. All Rights Reserved. The
                                information contained herein: (1) is proprietary
                                to Morningstar and/or its content providers; (2)
                                may not be copied or distributed; and (3) is not
                                warranted to be accurate, complete or timely.
                                Neither Morningstar nor its content providers
                                are responsible for any damages or losses
                                arising from any use of this information. Past
                                performance is no guarantee of future results.
                            </div>
                        )}
                    {['PIEQX'].includes(ticker) && (
                        <div className="footer-content">
                            MSCI makes no express or implied warranties or
                            representations and shall have no liability
                            whatsoever with respect to any MSCI data contained
                            herein. The MSCI data may not be further
                            redistributed or used as a basis for other indices
                            or any securities or financial products. This report
                            is not approved, reviewed, or produced by MSCI.
                        </div>
                    )}
                    <div className="footer-content">
                        Methodology for risk spectrum: We evaluate the standard
                        deviation and its resulting placement within a specific
                        risk/return category on an annual basis. A fund is
                        generally placed in a risk/return category based on the
                        10-year standard deviation of its performance. If a fund
                        is less than 10 years old, the actual fund performance
                        history is supplemented with the primary prospectus
                        benchmark history to obtain a full 10-year history, or
                        longest time period available up to 10 years. For an
                        Asset Allocation fund with less than 10 years of
                        performance history, sub-strategy returns are used. When
                        a sub-strategy is less than 10 years old, the actual
                        sub-strategy performance history is supplemented with
                        benchmark history to obtain a full 10-year history, or
                        longest time period available up to 10 years.
                    </div>
                </React.Fragment>
            )}

            <div className="footer-content">
                All investments are subject to market risk, including the
                possible loss of principal. Standard deviation of returns, a
                measure of price volatility, is one measure of risk. Please
                consult the funds&apos; prospectuses for a more complete
                discussion of the funds&apos; risks.
            </div>

            {RUSSEL_FUNDS.includes(trpCode) && (
                <div className="footer-content">
                    Russell Investment Group is the source and owner of the
                    trademarks service marks and copyrights related to the
                    Russell Indexes. Russell<sup>&reg;</sup> is a trademark of
                    Russell Investment Group.
                </div>
            )}

            {USHI_FUNDS.includes(trpCode) && (
                <React.Fragment>
                    <div className="footer-content">
                        The Fund commenced operations on May 19 2017.
                        Performance prior to that date reflects the performance
                        of the Class I of the Predecessor Fund. Predecessor Fund
                        performance reflects its actual operating expense at the
                        time and was not adjusted to reflect the impact of the
                        Funds current fees. Since inception returns are shown
                        from the inception date of the Predecessor Fund April 30
                        2013
                    </div>
                    <div className="footer-content">
                        ** The T. Rowe Price US High Yield Fund (“Fund”)
                        commenced operations on May 19 2017. At that time the
                        Fund received all of the assets and liabilities of the
                        Henderson High Yield Opportunities Fund (the
                        “Predecessor Fund”) and adopted its performance and
                        accounting history. The Fund and the Predecessor Fund
                        have substantially similar investment objectives and
                        strategies. The Predecessor Fund was managed by the same
                        portfolio manager as the Fund.
                    </div>
                </React.Fragment>
            )}
            <style jsx>{styles}</style>
        </div>
    </React.Fragment>
);

export default FundBookFooter;
